import client from './client'
import store from '@/store'

let authService = {}

authService.getCountries = async function() {
  try {
    const res = await client.get('/users/countries/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.getRoles = async function() {
  try {
    const res = await client.get('/users/roles/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.getIndustries = async function() {
  try {
    const res = await client.get('/users/industries/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.getCompanyTypes = async function() {
  try {
    const res = await client.get('/users/company-types/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.getCompanySizes = async function() {
  try {
    const res = await client.get('/users/company-sizes/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.getArcgisUses = async function() {
  try {
    const res = await client.get('/users/arcgis-uses/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.checkEmailAddress = async function(payload) {
  try {
    const res = await client.post('/attendees/check-email-address/', payload)
    return res.data
  } catch (error) {
    return error
  }
}

authService.registerUser = async function(payload) {
  try {
    const res = await client.post('/auth/register/', payload)
    return res.data
  } catch (error) {
    return error
  }
}

authService.loginUser = async function(payload) {
  try {
    const res = await client.post('/auth/', payload)
    return res.data
  } catch (error) {
    return error
  }
}

authService.refreshToken = async function(payload) {
  try {
    const res = await client.post('/auth/refresh/', payload)
    return res.data
  } catch (error) {
    return error
  }
}

authService.getUser = async function() {
  try {
    const res = await client.get('/users/user/')
    return res.data
  } catch (error) {
    return error
  }
}

authService.changePassword = async function(payload) {
  try {
    const res = await client.put('/users/user/change-password/', payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

authService.forgottenPassword = async function(payload) {
  try {
    const res = await client.put('/users/user/forgotten-password/', payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

authService.checkResetPasswordToken = async function(token) {
  try {
    const res = await client.get(
      `/users/user/check-reset-password-token/${token}/`
    )
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

authService.resetPassword = async function(token, payload) {
  try {
    const res = await client.put(
      `/users/user/reset-password/${token}/`,
      payload
    )
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

authService.logOut = async function() {
  try {
    const res = await client.post('/auth/logout/')
    return res.data
  } catch (error) {
    return error
  }
}

export default authService
